export enum DataStatus {
  INITIAL,
  LOADING,
  COMPLETE,
}
